const CAROUSEL_ITEMS = [
  {
    title: '悬疑推理季：烧脑神作一网打尽',
    desc: '精选全网口碑最高的悬疑推理类影视作品，从经典本格到社会派推理，层层反转让你欲罢不能。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20detective%20theme%20with%20warm%20coral%20and%20dark%20amber%20lighting%2C%20magnifying%20glass%20and%20shadows%20abstract%2C%20suspense%20atmosphere%2C%20cinematic%20noir%20vibe%2C%20no%20text%2C%20dramatic%20composition&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '美食地图：舌尖上的夏日之旅',
    desc: '跟随美食博主走遍全国，从街头小吃到精致料理，每一帧都是对味蕾的诱惑，适合配饭观看。',
    image: 'https://readdy.ai/api/search-image?query=Food%20adventure%20theme%20with%20warm%20golden%20lighting%2C%20culinary%20exploration%20abstract%2C%20vibrant%20coral%20and%20amber%20accents%2C%20gourmet%20atmosphere%2C%20no%20text%2C%20elegant%20food%20photography%20style&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '动漫狂欢：本季霸权番全收录',
    desc: '七月新番全面登陆，热血战斗、治愈日常、奇幻冒险应有尽有，二次元爱好者的终极乐园。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20vibrant%20abstract%20theme%20with%20warm%20coral%20and%20golden%20highlights%2C%20manga%20style%20dynamic%20composition%2C%20colorful%20energy%2C%20anime%20culture%20vibe%2C%20no%20text%2C%20modern%20illustration&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '纪录片之夜：探索世界的另一面',
    desc: '自然奇观、人文历史、科技前沿三大主题连播，用镜头带你领略这个星球上最震撼的真实故事。',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20exploration%20theme%20with%20warm%20earthy%20tones%2C%20nature%20and%20culture%20abstract%2C%20adventure%20atmosphere%2C%20cinematic%20wide%20landscape%20vibe%2C%20no%20text%2C%20epic%20composition&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
];

const TOPIC_ITEMS = [
  { label: '悬疑推理', count: '2.8万', hot: true },
  { label: '搞笑综艺', count: '3.5万', hot: true },
  { label: '美食探店', count: '2.1万', hot: false },
  { label: '旅行 Vlog', count: '1.9万', hot: false },
  { label: '科技数码', count: '1.6万', hot: false },
  { label: '动漫新番', count: '2.4万', hot: true },
  { label: '影视解说', count: '4.2万', hot: true },
  { label: '音乐分享', count: '1.3万', hot: false },
  { label: '游戏实况', count: '1.8万', hot: false },
  { label: '生活技巧', count: '2.0万', hot: false },
];

export default function CarouselTopicsSection() {
  return (
    <>
      {/* #carousel */}
      <section id="carousel" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-focus-2-line text-sm"></i>
              焦点专题
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              本期焦点专题推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              精心策划的四大主题内容专区
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            {CAROUSEL_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="group rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="aspect-[16/9] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-heading text-lg text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #topics */}
      <section id="topics" className="py-16 md:py-24 px-4 md:px-6 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-hashtag text-sm"></i>
              热门话题
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              大家都在看的热门话题
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md mx-auto">
              点击话题发现更多精彩内容
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {TOPIC_ITEMS.map((item, idx) => (
              <div
                key={idx}
                className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/60 hover:border-accent-300 hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
              >
                {item.hot && (
                  <i className="ri-fire-fill text-primary-500 text-xs"></i>
                )}
                <span className="text-sm font-medium text-foreground-950 whitespace-nowrap">{item.label}</span>
                <span className="text-xs text-foreground-500">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}